module.exports = __webpack_public_path__ + "img/about.f2b6ab4b.svg";